import { defineMessages } from 'react-intl';

export const messages: {
	created: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	externalPersonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	for: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	isAssigned: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	projectLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	taskLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	ticketLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	workItem: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	workItem: {
		id: 'dynamic-cards-search-page.work-item.label',
		defaultMessage: 'Work item',
		description:
			'Work item label shown as part of the work item search result metadata, e.g. "Work item • #1xxx • Updated 2 days ago"',
	},
	taskLabel: {
		id: 'dynamic-cards-search-page.work-item-task.label',
		defaultMessage: 'Task',
		description:
			'Task label shown as part of the work item search result metadata, e.g. "Task • #1xxx • Updated 2 days ago"',
	},
	projectLabel: {
		id: 'dynamic-cards-search-page.work-item-project.label',
		defaultMessage: 'Project',
		description:
			'Project label shown as part of the work item search result metadata, e.g. "Project • #1xxx • Updated 2 days ago"',
	},
	ticketLabel: {
		id: 'dynamic-cards-search-page.work-item-ticket.label',
		defaultMessage: 'Ticket',
		description:
			'Ticket label shown as part of the work item search result metadata, e.g. "Ticket • #1xxx • Updated 2 days ago"',
	},
	for: {
		id: 'dynamic-cards-search-page.work-item-status.for',
		defaultMessage: 'for',
		description: 'The conjunction between a status and date e.g. "On track for August"',
	},
	isAssigned: {
		id: 'dynamic-cards-search-page.work-item-assignee.assigned',
		defaultMessage: 'is assigned',
		description: 'Text that goes after assignee name',
	},
	created: {
		id: 'dynamic-cards-search-page.work-item-creator.created',
		defaultMessage: 'created',
		description: 'Text that goes after creator name',
	},
	externalPersonLabel: {
		id: 'dynamic-cards-search-page.externalPersonLabel',
		defaultMessage: 'External person',
		description: 'Label for external person in the search result title',
	},
});
